export default __webpack_public_path__ + "static/media/glitch09.cdd6c343.png";